import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path, Rect } from "react-native-svg";

export const IconStudioDisplay1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconStudioDisplay1"><Path d="M9 17H15V20.5C15 20.7761 14.7761 21 14.5 21H9.5C9.22386 21 9 20.7761 9 20.5V17Z" fill="currentColor"/><Rect x="2" y="3" width="20" height="13" rx="2.5" fill="currentColor"/></CentralIconBase>;
});

export default IconStudioDisplay1;
